/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from "axios";
import type { AxiosInstance } from "axios";
// import nprogress from "nprogress";
import type { AIOInterceptors, AIORequestConfig } from "./interface";

export default class AIORequest {
  private instance: AxiosInstance;
  private interceptors?: AIOInterceptors;
  //   private showNprogress: boolean; // 进度条

  /**
   * @param config 请求配置项
   */
  constructor(config: AIORequestConfig) {
    this.instance = axios.create(config);
    this.interceptors = config.interceptors;
    // this.showNprogress = config.showNprogress ?? true;

    // 单个实例中抽取的拦截器
    this.instance.interceptors.request.use(
      this.interceptors?.requestInterceptors,
      this.interceptors?.requestInterceptorsCatch
    );

    this.instance.interceptors.response.use(
      this.interceptors?.responseInterceptors,
      this.interceptors?.responseInterceptorsCatch
    );

    // 所有实例共有的拦截器
    this.instance.interceptors.request.use(
      (config) => {
        // 使用进度条
        // if (this.showNprogress) nprogress.start();
        // token
        return config;
      },
      (err) => {
        return Promise.reject(err);
      }
    );

    this.instance.interceptors.response.use(
      // 对响应的数据做处理
      (res) => {
        // if (this.showNprogress) nprogress.done();
        return res.data;
      },
      (err) => {
        // if (this.showNprogress) nprogress.done();
        return Promise.reject(err);
      }
    );
  }

  request<T = any>(config: AIORequestConfig<T>): Promise<T> {
    return new Promise((resolve, reject) => {
      // 单个请求的拦截器
      if (config.interceptors?.requestInterceptors)
        config = config.interceptors.requestInterceptors(config);
      //   if (config.showNprogress === false) this.showNprogress = config.showNprogress;
      this.instance
        .request<any, T>(config)
        .then((res) => {
          if (config.interceptors?.responseInterceptors)
            res = config.interceptors.responseInterceptors(res);
          //   this.showNprogress = true;
          resolve(res);
        })
        .catch((err) => {
          //   this.showNprogress = true;
          reject(err);
          return err;
        });
    });
  }

  get<T = any>(config: AIORequestConfig<T>): Promise<T> {
    return this.request<T>({ ...config, method: "GET" });
  }

  post<T = any>(config: AIORequestConfig<T>): Promise<T> {
    return this.request<T>({ ...config, method: "POST" });
  }

  delete<T = any>(config: AIORequestConfig<T>): Promise<T> {
    return this.request<T>({ ...config, method: "DELETE" });
  }

  patch<T = any>(config: AIORequestConfig<T>): Promise<T> {
    return this.request<T>({ ...config, method: "PATCH" });
  }
}

export const req = new AIORequest({
  baseURL: process.env.VUE_APP_BASE_URL,
  timeout: 5 * 1000,
});
